import React, { Dispatch, SetStateAction } from "react";
import Navigator from '../components/Navigation';
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ProtectedArticleGroup } from "../articleDetailPage/ProtectedArticleGroup";
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { hashPassword, hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Wavedivider } from "../components/Wavedivider";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from '../utils/useMetaTags';
import ProtectedPage from "../components/ProtectedPage";
import { QuoteBlock } from "../components/QuoteBlock";
import ProtectedSection from "../components/ProtectedSection";

function Essay260601(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
   
      
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY260601_PASSWORDS
      );
      const sectionLockHashes = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2606_SECTION_PASSWORDS
      );
      useMetaTags({
        title: '기억하기 - Lynkim',
        
        image: '/ogimage.png',
      });
      
      return (
        <>
        <ProtectedPage password={hashedPasswords} description="이 페이지의 비밀번호는 개인번호로 설정되어 있어요">
        <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
        <div className='fadeIn '>
            <ArticleTitle
                title={'기억하기'}
                description={'매일 아침 출근할 때 읽기'}
                category={'essay'}
                date={'2026.06.28.'}
                // thumbnail={image1}
            />
        </div>
        <Wavedivider/>
        <div className='articleLayout'>
           <ArticleTextSection      
                marginBottom={true}
                description={<div>
                    - 질척거리면서 스스로 흑역사를 만들거나 더이상 나를 스스로 안줏거리 정도로 만들지 말기 
                    <br/><br/>
                    - 헛된 희망이랍시고 매일 내 삶을 보여주기식에 빠져서 소중한 나의 시간 낭비하지 말기
                    <br/><br/>
                    - 과거는 과거로 보내주고, 지금 앞으로 어떻게 더 잘 살 것인지 지금의 나에게 집중하기
                    <br/><br/>
                    - 절대 스스로를 아프고 힘들게 해서 불행하게 만들지 말기 
                    <br/><br/>
                    - 이것도 다 지나가는 것이고, 흔한 이별 중 하나다 꼭 기억하고 이제 정말 진심으로 끊어내기
                    <br/><br/>
                    - 분명 다 시간이 해결해줄 거라는 것 잊지말기
                    <br/><br/>
                    - 나는 충분히 괜찮은 사람이고, 더 멋있게 살아가다보면 충분히 더 멋있고 좋은 사람 분명 만날 수 있다는 것 꼭 기억하기
                </div>}
                 />

        </div>
        </ProtectedPage>
        </>
      )
  }

export default Essay260601;